import { Skeleton } from '@/components/ui/skeleton';

export const ProjectAnalysisAdminTableLoading = () => {
  return (
    <div className="flex flex-col gap-4 w-full p-4">
      {Array.from({ length: 8 }).map((_, i) => (
        <Skeleton key={i} className="h-10 w-full" />
      ))}
    </div>
  );
};
